/**
 * author: Soumya Shreyas
 */
import React, { useEffect, useRef, useState } from "react";
import { Form } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import ForgotPasswordService from "../../core/service/ForgotPasswordService";
import "./ForgotPassword.scss";
import COMPANY_LOGO from "../../../src/images/logo.png";

const ForgotPassword = ({ t }) => {
  const [email, setEmail] = useState("");
  const { invite_key } = useParams();
  const [validated, setValidated] = useState(false);
  const [show, setShow] = useState(false);
  const navigate = useNavigate();
  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    setValidated(true);
    if (form.checkValidity() === false) {
      e.stopPropagation();
    } else {
      let obj = {
        email : email
      }
      ForgotPasswordService.requestPasswordLink(obj)
        .then((response) => {
          if (response.status === 200) {
            setShow(true);
          }
        })
        .catch((error) => {});
    }
  };
  const handleLogin = () => {
    navigate(`/login`);
  }
  return (
    <section className="Set_Pwd_page_section">
      <div className="row m-0">
        <div className="col-lg-6 col-md-6 p-0 Set_Pwd_leftBox">
          <div className="Set_Pwd_leftBox_Logo">
          <img src={COMPANY_LOGO} />
          </div>
        </div>
        <div className="col-lg-6 col-md-6 p-0 Set_Pwd_RightBox">
          <div className="Set_Pwd_Form">
            <div className="Set_Pwd_Form_in">
              {show ? (
                <>
                  <div className="mb-4 Set_Pwd_Form_in_head">
                    <h3>{t("Checkyourmail.label")}</h3>
                    <p>{t("Checkpasswordresetlink.label")}</p>
                  </div>
                  <div className="mb-4">
                  <button type="button" className="btn btn-primary w-100" onClick={handleLogin}>
                    {t("Backtologin.label")}
                  </button>
                  </div>

                 
                </>
              ) : (
                <>
                  <div className="mb-4 Set_Pwd_Form_in_head">
                    <h3>{t("forgotPassword.label")}</h3>
                  </div>
                  <Form
                    noValidate
                    validated={validated}
                    onSubmit={handleSubmit}
                  >
                    <div className="mb-4">
                      <div className="mb-2">
                        <label className="mb-1">
                          {t("Emailid.label")}
                        </label>
                        <input
                          type="email"
                          className="form-control"
                          id="email"
                          autoComplete="off"
                          value={email}
                          required
                          onChange={(e) => setEmail(e.target.value)}
                        />
                      </div>
                      <div className="pb-2 form-check">
                        <a className="Forgot_pass" href="/login">
                          {t("Backtologin.label")}
                        </a>
                      </div>
                    </div>

                    <button type="submit" className="btn btn-primary w-100 sbmBtn">
                      {t("Submit.label")}
                    </button>
                  </Form>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default withTranslation()(ForgotPassword);
